import { render, staticRenderFns } from "./PatientField.vue?vue&type=template&id=08e72a9a&scoped=true&"
import script from "./PatientField.vue?vue&type=script&lang=js&"
export * from "./PatientField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e72a9a",
  null
  
)

export default component.exports